/**
 * @tabler/icons-react v2.22.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTextDecrease = createReactComponent("text-decrease", "IconTextDecrease", [
  ["path", { d: "M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5", key: "svg-0" }],
  ["path", { d: "M4 13h7", key: "svg-1" }],
  ["path", { d: "M21 12h-6", key: "svg-2" }]
]);

export { IconTextDecrease as default };
//# sourceMappingURL=IconTextDecrease.js.map
